import { User } from '../admin/admin.types';
import { PipelineCandidate } from '../candidate/candidate.types';
import { PossibleLanguageItem } from '../languages/languages.types';
import { LocationBrief } from '../locations/locations.types';
import { OfferBrief } from '../offer/offer.types';
import { JobRequisition, RequisitionOpening } from '../requisitions/requisitions.types';
import { Stage } from '../stage/stage.types';
import { TalentPoolBrief } from '../talent-pools/talent-pools.types';

export interface PlacementBase {
  candidateId: number;
  createdAt: string;
  disqualifyReason?: string;
  departmentName: string;
  id: number;
  language: PossibleLanguageItem;
  offerId: number | null;
  talentPoolId: number | null;
  locationIds?: number[] | null;
  position: number;
  stageId: number;
  updatedAt: string;
  overdueAt: string | null;
  overdueDiff: number | null;
  positiveRatings?: number;
  ratingVisible?: boolean;
  hiredAt?: string;
  hiredBy?: User | null;
  hiredById?: number;
  timeToHire?: number;
  jobStartsAt?: string;
  adminsCount?: number;
  candidateDeleted?: boolean;
  openingId?: number | null;
  missingOpening?: boolean;
  workLocationId?: number | null;
  disqualifiedAt?: string | null;
}

export interface Placement extends PlacementBase {
  offer: OfferBrief | null;
  talentPool: TalentPoolBrief | null;
  stage: Stage;
  hiredInThisPlacement: boolean;
  hiredInOtherPlacement: boolean;
  opening?: PlacementOpening;
  locations?: LocationBrief[];
}

export interface PlacementReference extends Placement {
  type: 'Placement';
}

export type PlacementPosition = {
  newPosition: number;
  placement: Placement;
};

export interface JobPlacement extends Placement {
  offer: OfferBrief;
  offerId: number;
}

export interface TalentPoolPlacement extends Placement {
  talentPool: TalentPoolBrief;
  talentPoolId: number;
}

export interface PipelinePlacement extends JobPlacement {
  candidate: PipelineCandidate;
  disqualifyReasonId?: number;
  disqualifyRunActions?: boolean;
  removeFromSharingContainers?: boolean;
}

export enum DisqualifyKind {
  System = 'system',
  Admin = 'admin',
}

export type PlacementWithoutOpening = {
  id: number;
  candidate: Pick<PipelineCandidate, 'id' | 'photoThumbUrl' | 'name' | 'hasAvatar' | 'initials'>;
};

export type PlacementOpening = RequisitionOpening & { requisition: JobRequisition };
